import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileScreenComponent } from './mobile-screen.component';
import { CdkDrag, DragDropModule } from '@angular/cdk/drag-drop';
import { MaterialModuleMobi } from '../material/material.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { WidgetCoreModule } from '../widget-core/widget-core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppPermissionsPipe } from 'shared-library';


@NgModule({
  declarations: [
    MobileScreenComponent
  ],
  imports: [
    CommonModule,
    MaterialModuleMobi,
    DragDropModule,CdkDrag,
    MatTooltipModule,
    MatIconModule,
    WidgetCoreModule,
    ReactiveFormsModule,
    FormsModule,
    AppPermissionsPipe
  ],
  exports:[MobileScreenComponent]
})
export class MobileScreenModule { }
